module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_innlandet_neg.36f5c5e4.svg";